import React, {PureComponent} from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"

interface Props {
  id?: string,
  onClick: () => void,
  text: string
}

class BackLink extends PureComponent<Props> {
  render() {
    const {onClick, text, id} = this.props
    return (
      <Button id={id} tertiary onClick={onClick} marginBottom={2}>
        <Icon icon={IconTypes.chevronLeft} />
        <Para flush marginLeft={2}>
          <FormattedMessage id={text} />
        </Para>
      </Button>
    )
  }
}

export default BackLink
